export default __webpack_public_path__ + "static/media/csnet.fd9fc771.png";